
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-8'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            시스템 관리 - 팝업 {{ $route.query.popup_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.popup_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='popup_name'>팝업명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'popup_name'
                maxLength="50"
                placeholder = "팝업명을 입력해 주세요.(50자 이내)"
                v-model="formData.popupName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.popupNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='popup_link'>링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'popup_link'
                maxLength="200"
                placeholder = "링크를 입력해 주세요."
                v-model="formData.popupLink"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.popupLinkError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='popup_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="popup_status"
                v-model="formData.popupStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1080 x 1080px</p>
                <label for='popup_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.popup_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'popup_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_SquareBanner">
                  <img
                    :src="formData.popupImageUrl === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.popupImageUrl"
                    alt="이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.popupImageUrlError}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_popup_one,
  insert_popup,
  update_popup
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminPopupManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        popupName: '',
        popupLink: '',
        popupStatus: 1,
        popupImage: '',
        popupImageUrl: ''
      }),
      errorData: ref({
        popupNameError: '',
        popupLinkError: '',
        popupImageUrlError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.popupImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.popupImageUrl = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.popupName === '') {
        this.errorData.popupNameError = '팝업명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.popupNameError = ''
      }
      if (this.formData.popupLink === '') {
        this.errorData.popupLinkError = '링크를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.popupLinkError = ''
      }
      if (this.formData.popupImageUrl === '') {
        this.errorData.popupImageUrlError = '노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.popupImageUrlError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.popup_ID === undefined) {
          insert_popup(
            this.formData.popupName,
            this.formData.popupImage,
            this.formData.popupLink,
            this.formData.popupStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminPopupManagement'
          })
        } else {
          update_popup(
            this.$route.query.popup_ID,
            this.formData.popupName,
            this.formData.popupImage,
            this.formData.popupLink,
            this.formData.popupStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminPopupManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.popup_ID !== undefined) {
      get_popup_one(this.$route.query.popup_ID).then((result) => {
        this.formData.popupName = result[0].popup_name
        this.formData.popupLink = result[0].popup_link
        this.formData.popupStatus = result[0].popup_status
        this.formData.popupImageUrl = result[0].popup_image
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminPopupManagementAdd.vue